// import store from '../store';
import { instance } from './index.js'
import API from './index.js'
import store from '../store';





async function getSubsidiaries(company_id, snapshot_id) {
    let error_ = null;
    const url = `${API.API_URL}subsidiaries/list?company_id=${company_id}${snapshot_id ? '&snapshot_id=' + snapshot_id : ''}`

    const response = await API.instance.get(url).catch((error) => {
        console.error('Error fetching subsidiaries:', error.response);
        if (error.response.status > 400 && error.response.status < 500) {
            error_ = {error: error.response.data.message + ' (Subsidiary list)'};
        }
        store.dispatch('addNotification', {type: 'error', text: error_.error || `There was an error loading subsidiaries.\nPlease try again or contact the support`});
        return null
    })
    if (error_) {
        return []
    }
    store.dispatch('setValue', {key: 'subsidiaries', value: response.data.subsidiaries});
    return response.data;
}

async function addSubsidiary(subsidiary) {
    let error_ = null;
    const response = await API.instance.post(`${API.API_URL}subsidiaries/create`, subsidiary).catch((error) => {
        if (error.response.status > 400 && error.response.status < 500) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error adding subsidiary.\nPlease try again or contact the support`});
        return null
    })
    store.dispatch('addNotification', {type: 'success', text: `Subsidiary ${subsidiary.name} added successfully`});
    return response.data;
}

async function editSubsidiary(subsidiary) {
    let error_ = null;
    const response = await API.instance.post(`${API.API_URL}subsidiaries/edit`, subsidiary).catch((error) => {
        if (error.response.status > 400 && error.response.status < 500) {
            error_ = {error: error.response.data.message};
        }
        store.dispatch('addNotification', {type: 'error', text: `There was an error editing subsidiary.\nPlease try again or contact the support`});
        return null
    })
    store.dispatch('addNotification', {type: 'success', text: `Subsidiary ${subsidiary.name} edited successfully`});
    return response.data;
}


export default {
    getSubsidiaries,
    addSubsidiary,
    editSubsidiary,
}